export default "__VITE_ASSET__B8A5Xw1B__"